import { useRouterEvents } from "eddev/routing"
import { trackEvent } from "./tracking"

/**
 * A global link tracking component that tracks link clicks via router events.
 */
export function LinkTracking() {
  if (env.client && !env.admin) {
    useRouterEvents((e) => {
      if (e.type === "clicked" && e.mode !== "ignore") {
        // console.log("LinkTracking", e)
        const el = e.target
        if (el) {
          let title = el.getAttribute("aria-label") || el.getAttribute("title") || el.innerText
          if (title.length > 40) {
            title = ""
            if (env.dev) {
              console.warn("Link title is too long, not sending to Mixpanel:", el)
            }
          }
          trackEvent("Link Click", { LinkText: title, LinkUrl: e.href?.replace(document.location.origin, "") }, el)
        }
      }
    })
  }

  return null
}
